import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class DashboardApi {
  public static shop = process.env.VUE_APP_SHOP_BASE_URI
  public static arenas = process.env.VUE_APP_ARENA_HUB_BASE_URI
  public static core = process.env.VUE_APP_CORE_BASE_URI
  public static entity = 'dashboard'

  public static async arenaStats(arenaId: bigint): Promise<AxiosResponse> {
    return await axios.get(`${this.arenas}/arenas/${arenaId}/stats`)
  }

  public static async coreStats(arenaId: bigint): Promise<AxiosResponse> {
    return await axios.get(`${this.core}/arenas/${arenaId}/dashboard`)
  }

  public static async finance(
    arenaId: bigint,
    params: string,
  ): Promise<AxiosResponse> {
    return await axios.get(
      `${this.shop}/${this.entity}/finance?&arena_id=${arenaId}${params}`,
    )
  }

  public static async generateReport(data: object): Promise<AxiosResponse> {
    return await axios.get(
      `${this.shop}/${this.entity}/finance/generate-report`,
      data,
    )
  }
}
